import {
  useEffect,
  useState,
} from 'react'


/**
 * Returns `false` until `delayMS` milliseconds have passed since the
 * component mounted, and `true` from then on. Always returns `false`
 * when `delayMS` is not set.
 *
 * @param {Object} args
 * @param {Number} [args.delayMS]
 *
 * @returns {Boolean}
 */
export default function useHasElapsed({ delayMS }) {
  const [hasElapsed, setHasElapsed] = useState(false)

  useEffect(() => {
    if ( !delayMS ) {
      return
    }

    const timer = setTimeout(() => {
      setHasElapsed(true)
    }, delayMS)

    return () => {
      clearTimeout(timer)
    }
  }, [delayMS])

  return hasElapsed
}
